import {customerTimestamp} from './customer-data-display.js';
import {gpsFixTime} from './gps-zone.js';

// Receipt time describes transport, not when a buffered GPS fix was measured.
// Older rows with no confirmed device time stay unknown after profile setup.
export function positionTimeLabel(position, profile, locale = 'da-DK') {
  if (!position) return undefined;
  const received = customerTimestamp(position.receivedAt, locale);
  const da = locale === 'da-DK';
  const time = profile?.protocol !== 'gt06'||profile.timeZoneConfirmed === true ? gpsFixTime(position) : null;
  const measured = time == null ? undefined : customerTimestamp(new Date(time).toISOString(), locale);
  return [measured ? `GPS: ${measured}` : da ? 'GPS-tid ukendt' : 'GPS time unknown',
    received ? `${da ? 'Modtaget' : 'Received'}: ${received}` : null].filter(Boolean).join(' · ');
}
